import type { ValueOf } from './ValueOf';

// Add any new approval types to const object below which is used internally
export const ApprovalTypes = {
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  LANDING_PAGE: 'LANDING_PAGE',
  SITE_PAGE: 'SITE_PAGE',
  BLOG_POST: 'BLOG_POST',
  DEAL: 'DEAL',
  KNOWLEDGE_ARTICLE: 'KNOWLEDGE_ARTICLE',
  QUOTE: 'QUOTE',
  SOCIAL_BROADCAST: 'SOCIAL_BROADCAST',
  CONNECTED_APP: 'CONNECTED_APP',
} as const;

export type ApprovalType = ValueOf<typeof ApprovalTypes>;
